import { LLFonts } from './font';
import { LLTheme } from './theme';

export type LLComponentStyleFn<TStyles> = (arg: {
  theme: LLTheme;
  fonts: LLFonts;
}) => TStyles;

export type ComponentStyleProp<TStyles> = {
  styles?: Partial<TStyles>;
};

export type createStylesArg<TStyles> = {
  componentStyles: TStyles;
  stylesProp?: Partial<TStyles>;
};
